/* eslint-disable */
import React, {Fragment} from 'react'
import {ListItem} from '../../../styled'
import classNames from "classnames"
import {Nav, ContainerQueue, ListContainer} from './styled'
import { ReactComponent as ExpandMore } from 'images/icons/expandMore.svg'
import { ReactComponent as ExpandLess } from 'images/icons/expandLess.svg'

const Queue = props => {
    const {count, isLink, t, auth} = props
    const {filter, setFilter} = props.filter

    function getCount(q) {
        let total = 0
        const allCount = count.length > 0 ? count.filter(x => filter && filter.department && filter.department.includes(x.department_id)) : []
        allCount && allCount.map(x => Object.keys(x).map(y => typeof x[y] === 'object' && y !== "department_id" && filter.channel.includes(Number(y)) && Object.keys(x[y]).map(z => total += (q === z || (q === 'open' && (z === 'open_bot' || z === 'waiting' || z === 'awaiting_customer' || z === 'awaiting_operator'|| z === 'audio_video_run' || z === 'audio_video_queue')) || (q === 'closed') && (z === 'closed_bot' || z === 'closed_human')) && x[y][z])))
        return total > 0 ? total : '-'
    }


    return (
        <ContainerQueue ref={props.innerRef ?? null}>
            <input type="checkbox" id="queueSwitcher"
                   value={props.filterVisibleMobile}
                   onChange={({target}) => props.setFilterVisibleMobile({filterVisibleMobile: target.checked})}
            />
            <Nav>
                <h5>{t.Queue.title}</h5>
                <label htmlFor="queueSwitcher">
                        <span>
                            {filter.queue === 'abertos_bot' ? t.Queue.openBot : (filter.queue === 'novo' ? t.Queue.newProtocol : (
                                filter.queue === 'atendimento' ? t.Queue.waitingOperator : (filter.queue === 'retorno_cliente' ? t.Queue.waitingCustomer : (filter.queue === 'audio_video_run' ? `${t.Queue.audio_video} - em atendimento` : (
                                    filter.queue === 'abertos_humano' ? `${t.Queue.open} com agentes` : (filter.queue === 'fechados' ? t.Queue.closed : (filter.queue === 'fechados_bot' ? t.Queue.closedBot : (
                                        filter.queue === 'fechados_humano' ? t.Queue.closedHuman : (filter.queue === 'categoria' ? t.Queue.category : (filter.queue === 'abertos' ? t.Queue.open : (
                                            filter.queue === 'audio_video_queue' ? `${t.Queue.audio_video} - fila` : ('Todos'))))))))))))}
                        </span>
                    <ExpandMore className='more'/>
                    <ExpandLess className='less'/>
                </label>
                <ListContainer>
                    {filter && filter.type === 'human' ? <Fragment>
                        {auth && auth.role > 1 && <ListItem
                            className={classNames({blink: false}, 'new')}
                            title={t.Queue.newProtocol}
                            onClick={() => setFilter({queue: 'novo'})}
                            value={count && getCount('waiting')}
                            active={filter && filter.queue && filter.queue === 'novo'}
                        />}
                        <ListItem
                            className={classNames({blink: false})}
                            title={t.Queue.waitingOperator}
                            onClick={() => setFilter({queue:'atendimento'})}
                            value={count && getCount('awaiting_operator')}
                            active={filter && filter.queue && filter.queue === 'atendimento'}
                        />
                        <ListItem
                            title={t.Queue.waitingCustomer}
                            active={filter && filter.queue && filter.queue === 'retorno_cliente'}
                            onClick={() => setFilter({queue:'retorno_cliente'})}
                            value={count && getCount('awaiting_customer')}
                        />
                        <ListItem
                            title={`${t.Queue.audio_video} - fila`}
                            active={filter && filter.queue && filter.queue === 'audio_video_queue'}
                            onClick={() => setFilter({queue:'audio_video_queue'})}
                            value={count && getCount('video_voice_queue')} />
                        <ListItem
                            title={`${t.Queue.audio_video} - em atendimento`}
                            active={filter && filter.queue && filter.queue === 'audio_video_run'}
                            onClick={() => setFilter({queue:'audio_video_run'})}
                            value={count && getCount('video_voice_run')}  />

                        {/*<ListItem
                            title={t.Queue.workflow}
                            onClick={() => setFilter({queue:'workflow'})}
                            active={filter && filter.queue && filter.queue === 'workflow'}
                            className={classNames({blinkSLA: count && count.slaExpired}, 'category')}
                            value={count && getCount('workflow')}
                         />*/}

                        <ListItem
                            title={t.Queue.closedHuman}
                            onClick={() => setFilter({queue:'fechados_humano'})}
                            active={filter && filter.queue && filter.queue === 'fechados_humano'}
                            value={count && getCount('closed_human')}
                            className='closed'/>
                    </Fragment> : (filter && filter.type === 'bot' ? <Fragment>
                        <ListItem
                            title={t.Queue.openBot}
                            onClick={() => setFilter({queue:'abertos_bot'})}
                            active={filter && filter.queue && filter.queue === 'abertos_bot'}
                            value={count && getCount('open_bot')}/>
                        <ListItem
                            title={t.Queue.closedBot}
                            onClick={() => setFilter({queue:'fechados_bot'})}
                            active={filter && filter.queue && filter.queue === 'fechados_bot'}
                            value={count && getCount('closed_bot')}
                            className='closed'/>

                    </Fragment> : filter && filter.type === 'all' && <Fragment>
                        <ListItem
                            title={t.Queue.open}
                            onClick={() => setFilter({queue:'abertos'})}
                            active={filter && filter.queue && filter.queue === 'abertos'}
                            value={count && getCount('open')}
                            to={isLink && 'abertos'}/>
                        <ListItem
                            title={t.Queue.closed}
                            onClick={() => setFilter({queue:'fechados'})}
                            active={filter && filter.queue && filter.queue === 'fechados'}
                            value={count && getCount('closed')}
                            to={isLink && 'fechados'} className='closed'/>

                    </Fragment>)}
                </ListContainer>
            </Nav>
        </ContainerQueue>
    )

}

export default Queue